import React from 'react';
import MiCompBackground from '../../assets/img/Group 86.png';
import MiCompNewLogo2 from '../../assets/MiCompNewLogo2.png';
import MiCompBackground1 from '../../assets/img/Group.png';
import { Layout, Form, Input, Button, Card, Row, Col } from 'antd';
const { Content } = Layout;
class ForgetPassWord extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        isLoggingIn: false,
        IsActive: true,
      }
    }
    handleSubmit = (e) => {
      e.preventDefault();
      this.props.form.validateFields((err, values) => {
        if (!err) {
          this.setState({ isLoggingIn: true });
          this.props.handleAuthentication(values);
        }
      });
    }
    render() {
      const { getFieldDecorator } = this.props.form;
      return (
        <Layout className="mi_comp_height100">
          <Content className="mi_app_background mi_comp_height100">
            <Row span={24} className="mi_comp_height100">

              <Col md={12} xs={24} className="mi_comp_height100">
                <Card align="center" style={{padding:'15px'}} className="mi_login_card" cover={<img alt="example"style={{ width: '120px',marginLeft:'-188px' }}src={MiCompNewLogo2} />} >
                  <h4 style={{ color: '#000000a8',marginBottom: '30px' }}>Please enter your email for set new password</h4>
                  <div style={{marginLeft:'-10px'}}>    <Form onSubmit={this.handleSubmit} direction="vertical" align="center" className="login-form">
                    <Form.Item className="mi_input_login">
                      {getFieldDecorator('email', {
                        rules: [{ required: true, message: 'Please enter your Email!' }],
                      })(
                        <Input style={{ border: '1px solid black' ,borderRadius:'20px'}} prefix={<i className="fa fa-user" style={{ color: 'rgba(0, 0, 0, 0.25)' }} />} placeholder="Email" />
                      )}
                    </Form.Item>
                    <Form.Item>
                      <Button htmlType="submit" className="mi_login_button submit-button" style={{ borderColor: 'black',borderRadius:'20px' }}>
                        Submit
                                </Button>
                    </Form.Item>
                  </Form>
                  </div>
                </Card>
              </Col>
              <Col md={12} xs={0} className="mi_comp_height100 mi_comp_height1001">
              <Card align="center" className="ant-input-rectang mi_login_card1" >
                   <p className='ant-text'>Welcome To MiComp</p>
                   <img className='ant-login-image' alt="example" style={{ width: '80px',float:'left',marginLeft: '15px'}} src={MiCompBackground1} />
                 <img className='ant-login-image' alt="example" style={{ width:'360px',bottom:'0',marginTop:'-47px'}}  src={MiCompBackground} />
                </Card>
              </Col>
            </Row>
          </Content>
        </Layout>
      );
    }
  }
  export default ForgetPassWord;